// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_2q5pJp","subcopy":"_2crWHC"};